import $ from 'jquery';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { $get, $getWithOutRedirect } from 'src/utils/httpUtil';

/**
 * 判断是否失效或者是否登录
 */
export const isLogin = () => {
    // 先取token
    if (localStorage.getItem('userToken') === null) {
        return false;
        // 判断时间失效
    }
    if (new Date().getTime() / 1000 - parseInt(localStorage.getItem('expiresTime')) > 0) {
        return false;
    }
    return true;
};

/**
 * 获取access_token
 */
export const getUserToken = () => localStorage.getItem('userToken');

/**
 * 设置access_token
 * @param {String} token
 */
export const setUserToken = (token) => {
    localStorage.setItem('userToken', token);
};

/**
 * 获取失效时间
 */
export const getExpiresTime = () => localStorage.getItem('expiresTime');

/**
 * 设置失效时间
 * @param {Data} time
 */
export const setExpiresTime = (time) => {
    localStorage.setItem('expiresTime', time);
};

/**
 * 获取用户名
 */
export const getUserName = () => sessionStorage.getItem('userName');

/**
 * 设置用户名
 * @param {String} name
 */
export const setUserName = (name) => {
    sessionStorage.setItem('userName', name);
};

/**
 * 获取用户类型
 */
export const getUserType = () => sessionStorage.getItem('userType');

/**
 * 设置用户类型
 * @param {String} type
 */
export const setUserType = (type) => {
    sessionStorage.setItem('userType', type);
};

// 查询用户信息
export const getUserInfo = () =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/userInfo`;
        $get(url).then((res) => {
            resolve(res.data || {});
        });
    });

// 仅用户官网首页和开发者中心首页获取用户姓名
export const getUserNameFun = () =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/userInfo`;
        $getWithOutRedirect(url).then((res) => {
            resolve(res.data || {});
        });
    });

// 清理登出信息
export const cleanUserInfo = () => {
    // 清空登出状态
    localStorage.setItem('islogin', 0);
    // 删除相关信息
    localStorage.removeItem('userToken');
    localStorage.removeItem('userName');
    localStorage.removeItem('expiresTime');
};

// 用户登出
export const userLogout = () => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    const locationUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
    const authUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/logout?needRedirect=false`;
    const consoleUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/signOut`;
    return new Promise((resolve, reject) => {
        const authPromise = new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: authUrl,
                crossDomain: true, // 设置跨域为true
                xhrFields: {
                    withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
                },
                complete(res) {
                    resolve(true);
                },
            });
        });
        const consolePromise = new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: consoleUrl,
                crossDomain: true, // 设置跨域为true
                xhrFields: {
                    withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
                },
                complete(res) {
                    resolve(true);
                },
            });
        });
        Promise.all([authPromise, consolePromise]).then((res) => {
            resolve(locationUrl);
        });
    });
};

// 用户登出
export const userLogin = () => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    const locationUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
    window.location = locationUrl;
};



// WEBPACK FOOTER //
// ./src/utils/loginUtils.js